'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var events = require('events');

var MovingAverage = require('@vascosantos/moving-average');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var MovingAverage__default = /*#__PURE__*/_interopDefaultLegacy(MovingAverage);

var Stat = /*#__PURE__*/function (_events$EventEmitter) {
  _inherits(Stat, _events$EventEmitter);

  var _super = _createSuper(Stat);

  function Stat(initialCounters, options) {
    var _this;

    _classCallCheck(this, Stat);

    _this = _super.call(this);
    _this._options = options;
    _this._queue = [];
    _this._stats = {};
    _this._frequencyLastTime = Date.now();
    _this._frequencyAccumulators = {};
    _this._movingAverages = {};
    _this._update = _this._update.bind(_assertThisInitialized(_this));
    initialCounters.forEach(function (key) {
      _this._stats[key] = BigInt(0);
      _this._movingAverages[key] = {};

      _this._options.movingAverageIntervals.forEach(function (interval) {
        var ma = _this._movingAverages[key][interval] = MovingAverage__default["default"](interval);
        ma.push(_this._frequencyLastTime, 0);
      });
    });
    _this._enabled = _this._options.enabled;
    return _this;
  }

  _createClass(Stat, [{
    key: "enable",
    value: function enable() {
      this._enabled = true;
    }
  }, {
    key: "disable",
    value: function disable() {
      this._disabled = true;
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this._timeout) {
        clearTimeout(this._timeout);
      }
    }
  }, {
    key: "snapshot",
    get: function get() {
      return Object.assign({}, this._stats);
    }
  }, {
    key: "movingAverages",
    get: function get() {
      return Object.assign({}, this._movingAverages);
    }
  }, {
    key: "push",
    value: function push(counter, inc) {
      if (this._enabled) {
        this._queue.push([counter, inc, Date.now()]);

        this._resetComputeTimeout();
      }
    }
  }, {
    key: "_resetComputeTimeout",
    value: function _resetComputeTimeout() {
      if (this._timeout) {
        clearTimeout(this._timeout);
      }

      this._timeout = setTimeout(this._update, this._nextTimeout());
    }
  }, {
    key: "_nextTimeout",
    value: function _nextTimeout() {
      var urgency = this._queue.length / this._options.computeThrottleMaxQueueSize;
      return Math.max(this._options.computeThrottleTimeout * (1 - urgency), 0);
    }
  }, {
    key: "_update",
    value: function _update() {
      this._timeout = null;

      if (this._queue.length) {
        var last;

        while (this._queue.length) {
          var op = last = this._queue.shift();

          op && this._applyOp(op);
        }

        last && this._updateFrequency(last[2]);
        this.emit('update', this._stats);
      }
    }
  }, {
    key: "_updateFrequency",
    value: function _updateFrequency(latestTime) {
      var _this2 = this;

      var timeDiff = latestTime - this._frequencyLastTime;

      if (timeDiff) {
        Object.keys(this._stats).forEach(function (key) {
          _this2._updateFrequencyFor(key, timeDiff, latestTime);
        });
      }

      this._frequencyLastTime = latestTime;
    }
  }, {
    key: "_updateFrequencyFor",
    value: function _updateFrequencyFor(key, timeDiffMS, latestTime) {
      var count = this._frequencyAccumulators[key] || 0;
      this._frequencyAccumulators[key] = 0;
      var hz = count / timeDiffMS * 1000;
      var movingAverages = this._movingAverages[key];

      if (!movingAverages) {
        movingAverages = this._movingAverages[key] = {};
      }

      this._options.movingAverageIntervals.forEach(function (movingAverageInterval) {
        var movingAverage = movingAverages[movingAverageInterval];

        if (!movingAverage) {
          movingAverage = movingAverages[movingAverageInterval] = MovingAverage__default["default"](movingAverageInterval);
        }

        movingAverage.push(latestTime, hz);
      });
    }
  }, {
    key: "_applyOp",
    value: function _applyOp(op) {
      var key = op[0];
      var inc = op[1];

      if (typeof inc !== 'number') {
        throw new Error("invalid increment number: ".concat(inc));
      }

      if (!Object.prototype.hasOwnProperty.call(this._stats, key)) {
        this._stats[key] = BigInt(0);
      }

      this._stats[key] = BigInt(this._stats[key]) + BigInt(inc);

      if (!this._frequencyAccumulators[key]) {
        this._frequencyAccumulators[key] = 0;
      }

      this._frequencyAccumulators[key] += inc;
    }
  }]);

  return Stat;
}(events.EventEmitter);

exports.Stat = Stat;